// extracted by mini-css-extract-plugin
export var text = "_6u-0";